<template>
  <div class="quality">
    <div class="navTop">
      <img src="../../../../static/image/house.png" alt="">
      <span>质量管理</span>
      <span style="padding:0">></span>
      <span>{{title}}</span>
      <div class="right clearfix">
        <div :class="{ activeColor: toggle === 0 }" @click.stop="checkTab(0)">高质量管理</div>
        <div :class="{ activeColor: toggle === 1 }" @click.stop="checkTab(1)">全面检验质量管理</div>
      </div>
    </div>
    <div class="ab-main">
      <quality v-if="toggle === 0"></quality>
      <examination v-if="toggle === 1"></examination>
    </div>
  </div>
</template>

<script>
import quality from './component/quality.vue'
import examination from './component/examination.vue'

export default {
  components: {
    quality,
    examination
  },

  data() {
    return {
      toggle: 0,
      title: ''
    }
  },
  mounted() {
    const vm = this
    vm.toggle = vm.$route.query.activeName ? parseInt(vm.$route.query.activeName) : 0
    this.checkTab(vm.toggle)
  },
  methods: {
    checkTab(index) {
      const vm = this
      if (index === 0) {
        vm.toggle = 0
        vm.title = '高质量管理'
      }
      if (index === 1) {
        vm.toggle = 1
        vm.title = '全面检验质量管理'
      }
    }
  },
  watch: {
    $route(to, from) {
      let vm = this
      vm.toggle = vm.$route.query.activeName ? parseInt(vm.$route.query.activeName) : 0
      vm.checkTab(vm.toggle)
    }
  }
}
</script>

<style lang="scss" scoped>
.quality {
  .navTop {
    padding: 0 8%;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #999999;
    color: #999999;
    span {
      padding: 0 6px;
    }
    img {
      vertical-align: middle;
    }
    .right {
      float: right;
      div {
        float: left;
        height: 100%;
        padding: 0 20px;
        color: #000;
        text-align: center;
        cursor: pointer;
      }
      .activeColor {
        background-color: #0068b7;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/quality/quality.vue